import { configureStore } from '@reduxjs/toolkit'
import modalSlice from '../features/common/modalSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'
import headerSlice from '../features/common/headerSlice'
import userSlice from '../features/common/userSlice'

const store = configureStore({
  reducer: {
      modal : modalSlice,
      rightDrawer : rightDrawerSlice,
      header : headerSlice,
      user : userSlice
  }
})

export default store